export const GTM_DATA_LAYER = 'GTM-TP99CVZ';
export const getTagManagerArgs = () => ({
  gtmId: GTM_DATA_LAYER,
  dataLayer: {},
});
